import { NamingConvention } from "namirasoft-core";

export type NSNameParserStructure =
    {
        // Name
        name_namirasoft: string;
        name_short: string;

        // Title
        title_namirasoft: string;
        title_short: string;

        // Class
        class_namirasoft: string;
        class_short: string;
    };

export class NSNameParser
{
    // Input
    public name_full: string;
    public title_full: string;

    // Is
    public isAPI: boolean;
    public isConsole: boolean;
    public isLibrary: boolean;
    public isNPM: boolean;
    public isPHP: boolean;
    public isAccountAPI: boolean;

    public api: NSNameParserStructure = {
        // Name
        name_namirasoft: "",
        name_short: "",

        // Title
        title_namirasoft: "",
        title_short: "",

        // Class
        class_namirasoft: "",
        class_short: "",
    };

    public console: NSNameParserStructure = {
        // Name
        name_namirasoft: "",
        name_short: "",

        // Title
        title_namirasoft: "",
        title_short: "",

        // Class
        class_namirasoft: "",
        class_short: "",
    };

    public library: NSNameParserStructure = {
        // Name
        name_namirasoft: "",
        name_short: "",

        // Title
        title_namirasoft: "",
        title_short: "",

        // Class
        class_namirasoft: "",
        class_short: "",
    };
    public command: {
        name: string
    } = { name: "" };

    constructor(name_full: string, title_full: string)
    {
        // Input
        this.name_full = name_full;
        this.title_full = title_full;

        // Is
        this.isAPI = /^namirasoft(-\w*)*-api(-\w*)*-v\d+$/gm.test(name_full);
        this.isConsole = /^namirasoft-(\w+-)+console$/gm.test(name_full);
        this.isLibrary = !this.isAPI && !this.isConsole && /^namirasoft-\w+/gm.test(name_full);
        this.isNPM = this.isLibrary && /NPM Package$/gm.test(title_full);
        this.isPHP = this.isLibrary && /PHP Package$/gm.test(title_full);
        this.isAccountAPI = /^namirasoft-account-api-v\d+$/gm.test(name_full);

        if (this.isAPI)
        {
            // Name
            this.api.name_namirasoft = this.name_full.replace(/(-api)?-v\d+$/gm, "");
            this.api.name_short = this.api.name_namirasoft.replace(/^namirasoft-/gm, "");

            // Title
            this.api.title_namirasoft = this.title_full.replace(/(\sAPI)?\sV\d+$/gm, "");
            this.api.title_short = this.api.title_namirasoft.replace(/^Namirasoft\s/gm, "");

            // Class
            this.api.class_namirasoft = NamingConvention.auto.convert(this.api.title_namirasoft, NamingConvention.Pascal_Case);
            this.api.class_short = NamingConvention.auto.convert(this.api.title_short, NamingConvention.Pascal_Case);

            // Command
            this.command.name = this.api.name_namirasoft;
        }

        if (this.isConsole)
        {
            // Name
            this.console.name_namirasoft = this.name_full.replace(/-console$/gm, "");
            this.console.name_short = this.console.name_namirasoft.replace(/^namirasoft-/gm, "");

            // Title
            this.console.title_namirasoft = this.title_full.replace(/\sConsole$/gm, "");
            this.console.title_short = this.console.title_namirasoft.replace(/^Namirasoft\s/gm, "");

            // Class
            this.console.class_namirasoft = NamingConvention.auto.convert(this.console.title_namirasoft, NamingConvention.Pascal_Case);
            this.console.class_short = NamingConvention.auto.convert(this.console.title_short, NamingConvention.Pascal_Case);
        }

        if (this.isLibrary)
        {
            // Name
            this.library.name_namirasoft = this.name_full;
            this.library.name_short = this.library.name_namirasoft.replace(/^namirasoft-/gm, "");

            // Title
            this.library.title_namirasoft = this.title_full.replace(/\s(NPM|PHP)\sPackage$/gm, "");
            this.library.title_short = this.library.title_namirasoft.replace(/^Namirasoft\s/gm, "");

            // Class
            this.library.class_namirasoft = NamingConvention.auto.convert(this.library.title_namirasoft, NamingConvention.Pascal_Case);
            this.library.class_short = NamingConvention.auto.convert(this.library.title_short, NamingConvention.Pascal_Case);

            // Command
            this.command.name = this.library.name_namirasoft;
        }

        this.command.name = this.command.name.replace("namirasoft-", "ns-");
    }
};